import AmexCenturionNY from './AmexCenturionNY';

export default AmexCenturionNY;
